<!--人才列表-->
<template>
    <div class="filterJob" :class="$IsMobile ? 'mobile' : ''">
        <el-input class="input-with-select" placeholder="请输入关键字" clearable v-model="searchParam.keyword" maxlength="20" show-word-limit>
            <el-button slot="append" icon="el-icon-search" @click="search">搜索人才</el-button>
        </el-input>
        <ul>
            <li :class="{ active: showMenu }" @click="showMenu = true">
                <span class="liLabel">职能：</span>
                <el-radio-group v-model="searchParam.function" @change="search">
                    <el-radio-button label="">不限</el-radio-button>
                    <el-radio-button v-for="item in expectPositionOptions" :label="item.value" :key="item.id">
                        {{item.label}}
                    </el-radio-button>
                </el-radio-group>
            </li>
            <li :class="{ active: showMenu }" @click="showMenu = true">
                <span class="liLabel">城市：</span>
                <el-radio-group v-model="searchParam.workplace" @change="search">
                    <el-radio-button label="">不限</el-radio-button>
                    <el-radio-button v-for="(item, index) in workplaceOption" :label="item" :key="index">
                        {{item}}
                    </el-radio-button>
                </el-radio-group>
            </li>
            <li :class="{ active: showMenu }" @click="showMenu = true">
                <span class="liLabel">技能：</span>
                <el-radio-group v-model="searchParam.skills" @change="search">
                    <el-radio-button label="">不限</el-radio-button>
                    <el-radio-button v-for="item in skillsOption" :label="item.value" :key="item.id">
                        {{item.label}}
                    </el-radio-button>
                </el-radio-group>
            </li>
        </ul>
    </div>
</template>
<script>
    import {getTreeListByDictType} from '@/api/dict';

    export default {
        name: 'Function',
        data() {
            return {
                expectPositionOptions: [],  // 职能选项
                skillsOption: [],   // 技能选项
                searchParam: {
                    function: '',   // 职能
                    workplace: '',  // 工作地点
                    skills: '',     // 技能
                    keyword: '',    // 关键词
                },
                showMenu: false
            }
        },
        created() {
            this.$store.dispatch("resume/getResumeCityList");
            this.loadExpectPositionOptions();
            this.loadSkillsOption();
        },
        computed:{
            /** 查询条件参数*/
            searchParams() {
                return this.$store.state.resume.searchParams;
            },
            workplaceOption() {
                return this.$store.state.resume.workplaceOption;
            }
        },
        methods: {
            loadSkillsOption() {
                getTreeListByDictType("skill").then(response => {
                    this.skillsOption = response.data
                });
            },
            loadExpectPositionOptions() {
                getTreeListByDictType("function").then(response => {
                    this.expectPositionOptions = response.data
                });
            },
            check(value) {
                if (value.length>0) {
                    if (value[value.length-1]==='') {
                        return value.splice(-1)
                    }else {
                        if (value.length>1 && value[0]==='') {
                            return value.splice(1)
                        }
                    }
                }else {
                    value.unshift('')
                    return value.splice(-1)
                }
                return value
            },
            /** 获取更多简历列表*/
            search(){
                this.searchParams.function = this.searchParam.function; // 职能
                this.searchParams.workplace = this.searchParam.workplace;    // 工作地点
                this.searchParams.skills = this.searchParam.skills;  // 技能
                this.searchParams.keyword = this.searchParam.keyword;   // 关键词
                this.searchParams.pageNumber = 1;   // 页码
                this.$store.dispatch("resume/getResumeList")
                this.showMenu = false;
            },
        },
    }
</script>